<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
@import url('assets/css/base.css');
#app {
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue